import { render } from "./EditWarningRules.vue?vue&type=template&id=a28c71f2&scoped=true&ts=true"
import script from "./EditWarningRules.vue?vue&type=script&lang=ts"
export * from "./EditWarningRules.vue?vue&type=script&lang=ts"

import "./EditWarningRules.vue?vue&type=style&index=0&id=a28c71f2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28c71f2"]])

export default __exports__